// extracted by mini-css-extract-plugin
export var imgWidth = "GuideCard-module--imgWidth--i5s1N";
export var imgFormatting = "GuideCard-module--imgFormatting--xeuC3";